import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ClientReducerState } from 'client/reducers';
import { logout } from 'client/actions/api';
import css from './User.scss';

type Props = ConnectedProps<typeof connector>;

class User extends Component<Props> {
	get avatar() {
		const { user } = this.props;

		if (user.provider === 'sms') {
			return user.sms?.picture || '';
		}

		return user.google?.picture || '';
	}

	get initials() {
		const { user } = this.props;
		const name = user.google?.name || 'No Name';
		const nameSplit = name.split(' ');
		return nameSplit[0].charAt(0).toUpperCase() + nameSplit[1].charAt(0).toUpperCase();
	}

	logout = async () => {
		// delete user
		await this.props.logout();

		// restart story from the beginning
		window.location.replace(window.location.href.replace(/\?.*/, ''));
	};

	render() {
		if (!this.props.user.provider) return null;

		return (
			<div className={css.user}>
				<button type="button" className={css.userBtn}>
					<span
						className={css.userPic}
						style={{
							backgroundImage: this.avatar ? `url(${this.avatar})` : '',
						}}
					>
						{!this.avatar ? this.initials : ''}
					</span>
				</button>
				<button className={css.logout} type="button" onClick={this.logout}>
					Logout
				</button>
			</div>
		);
	}
}

const connector = connect(
	({ user }: ClientReducerState) => ({
		user,
	}),
	{ logout }
);

export default connector(User);
